var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"90%","height":"400px","margin":"0 auto"},attrs:{"id":"main"}}),_c('div',{staticStyle:{"width":"90%","height":"400px","margin":"0 auto"},attrs:{"id":"main2"}}),_c('div',{staticStyle:{"width":"90%","height":"650px","margin":"0 auto"},attrs:{"id":"main3"}})])
}]

export { render, staticRenderFns }